import type { APICatalogSortItem } from '~/api/catalogApi'
import type { TSortItem } from '~/layers/catalog/data/types'

export const fromCatalogApi = (item: APICatalogSortItem): TSortItem => {
  return {
    name: item.title,
    nameRu: item.titleRu || null,
    code: item.sortBy,
    direction: item.order,
  }
}
